import { Box3, Group, Mesh, Vector3 } from 'three';

export const getObjectSize = (mesh: Mesh | Group): Vector3 => {
  const box = new Box3().setFromObject(mesh);
  const size = new Vector3();
  box.getSize(size);
  return size;
};
